export const DECIMAL_UNITS = [
  'B',
  'KB',
  'MB',
  'GB',
  'TB',
  'PB',
  'EB',
  'ZB',
  'YB',
] as const;
export const BINARY_UNITS = [
  'B',
  'KiB',
  'MiB',
  'GiB',
  'TiB',
  'PiB',
  'EiB',
  'ZiB',
  'YiB',
] as const;

export const DECIMAL_BASE = 1000;
export const BINARY_BASE = 1024;

export const UNIT_MAP: Record<string, number> = {
  // Decimal units (base 1000)
  b: 1,
  byte: 1,
  bytes: 1,
  kb: 1000,
  mb: 1000 ** 2,
  gb: 1000 ** 3,
  tb: 1000 ** 4,
  pb: 1000 ** 5,
  eb: 1000 ** 6,
  zb: 1000 ** 7,
  yb: 1000 ** 8,
  // Binary units (base 1024)
  kib: 1024,
  mib: 1024 ** 2,
  gib: 1024 ** 3,
  tib: 1024 ** 4,
  pib: 1024 ** 5,
  eib: 1024 ** 6,
  zib: 1024 ** 7,
  yib: 1024 ** 8,
};
